module.exports = __webpack_public_path__ + "assets/img/btn5@2x.f4d630ae.png";